export default class Menu {
    constructor(btnSelector, tabSelector, txtSelector) {
      this.html = document.querySelector('html');
      this.btn = document.querySelector(btnSelector);
      this.tab = document.querySelector(tabSelector);
      this.txtElements = document.querySelectorAll(txtSelector);
      this.navLinks = document.querySelectorAll('.header_nav a:not([target="_blank"])');
      this.expanded = false;
      this.scrollPosition = null;
      this.bindEvents();
    }

    bindEvents() {
      this.btn.addEventListener('click', () => {
          this.toggle();
      });

      this.navLinks.forEach(link => {
        link.addEventListener('click', () => {
            this.close();
        });
      });
    }

    unbindEvents() {
      this.btn.removeEventListener('click', () => {
          this.toggle();
      });

      this.navLinks.forEach(link => {
        link.removeEventListener('click', () => {
            this.close();
        });
      });
    }

    toggle() {
      this.expanded = !this.expanded;
      this.btn.setAttribute('aria-expanded', this.expanded);
      this.tab.setAttribute('aria-hidden', !this.expanded);
      if (this.expanded) {
          this.open();
      } else {
          this.close();
      }
    }

    open() {
      this.scrollPosition = window.pageYOffset;
      this.html.classList.add('hidden');
      this.btn.classList.add('is_expanded');
      this.tab.classList.add('is_open');

      this.txtElements.forEach(el => {
        el.textContent = 'close';
      });
    }

    close() {
      this.html.classList.remove('hidden');
      this.btn.classList.remove('is_expanded');
      this.tab.classList.remove('is_open');

      this.txtElements.forEach(el => {
        el.textContent = 'menu';
      });
    }
}
